import { FormContext, iControlProps, iChoice } from "../types";
import Container from "./container";
import React from "react";
import RadioTraditional from "./radio-traditional";
import RadioButtonGroup from "./radio-button-group";

export type RadioProps = iControlProps & {
    context?: FormContext;
    choices: iChoice[];
    id?: string | number;
};

const Radio = (props: RadioProps) => {
    const isTraditionalRadio = props.cssClass?.includes("u-radio-traditional");

    return (
        <Container {...props} id={props.id}>
            {isTraditionalRadio ? (
                <RadioTraditional {...props} />
            ) : (
                <RadioButtonGroup {...props} />
            )}
        </Container>
    );
};

Radio.defaultProps = {
    choices: []
};

export default Radio;
